export default class Repeater {

    constructor() {
        this.addResult();
        this.removeResult();
        this.cleanForm();
    }

    addResult() {
        let _this = this;
        $(document).on('click', '.repeater-add-result', function () {
            let $addBtn = $(this);
            let $repeater = $addBtn.closest('.repeater');
            let elementIndex = $repeater.data('element-last-index') + 1;
            let namespace = _this.buildNamespace($repeater);

            let resultForm = $('<div class="repeater-result" data-result-index="' + elementIndex + '">' + $repeater.children('.repeater-template:first').html() + '</div>');
            $addBtn.closest('.row').before(resultForm);
            $repeater.data('element-last-index', elementIndex)

            resultForm.find('.repeater-input').each(function (index) {
                let name = $(this).attr('name');
                let nameParts = name.replace(namespace, '');
                nameParts = nameParts.replace(/^\[\d+\]/, '');
                nameParts = nameParts.replace(/^\[\]/, '');

                $(this).attr('name', namespace + '[' + elementIndex + ']' + nameParts);
                $(this).attr('id', namespace + '[' + elementIndex + ']' + nameParts);
            });
        })
    }

    removeResult() {
        $(document).on('click', '.repeater-remove-result', function () {
            $(this).closest('.repeater-result').remove();
        })
    }

    cleanForm() {
        $(function () {
            $('.repeater').closest('form').submit(function (e) {
                $(this).find('.repeater-template').remove();
            });
        });
    }

    buildNamespace($repeater)
    {
        if ($repeater.data('has-parent') && $repeater.closest('.repeater-result') != undefined) {
            let $parentResult = $repeater.closest('.repeater-result');
            return this.buildNamespace($parentResult.closest('.repeater')) + '[' + $parentResult.data('result-index') + ']' + $repeater.data('namespace-without-parent');
        }

        return $repeater.data('namespace');
    }
}
